import { Directive, HostListener, ElementRef, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[telefoneMask]',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TelefoneMaskDirective),
      multi: true
    }
  ]
})
export class TelefoneMaskDirective implements ControlValueAccessor {
  private onTouched: () => void = () => {};
  private onChange: (_: any) => void = () => {};
  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
     const inputEvent = event as InputEvent;

    if (
      inputEvent.inputType === 'deleteContentBackward' ||
      inputEvent.inputType === 'deleteContentForward'
    ) {
      this.onChange(this.el.value.replace(/\D/g, ''));
      return;
    }

    const cursorPosition = this.el.selectionStart;
    let valor = this.el.value.replace(/\D/g, '');
    
    if (valor.length === 0) {
      this.el.value = '';
      this.onChange(null);
      return;
    }
    
    let valorMascara = '';
    if (valor.length > 10) {
      valorMascara = valor.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
    } else if (valor.length > 5) {
      valorMascara = valor.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
    } else if (valor.length > 2) {
      valorMascara = valor.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
    } else {
      valorMascara = valor.replace(/^(\d*)/, '($1');
    }
    
    this.el.value = valorMascara;
    
    setTimeout(() => {
      if (cursorPosition === 1) this.el.setSelectionRange(1, 1);
      else if (cursorPosition === 3) this.el.setSelectionRange(4, 4);
      else if (cursorPosition === 9) this.el.setSelectionRange(10, 10);
      else if (cursorPosition === 10) this.el.setSelectionRange(11, 11);
    });
    
    this.onChange(valor);
  }
  

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }

  writeValue(value: any): void {
    if (!value) {
      this.el.value = '';
    } else {
      this.el.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.el.disabled = isDisabled;
  }
}
